import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { fetchWrapper, getTeamIdFromURL } from '../../../../../_helpers';
import { VscLoading } from 'react-icons/vsc';
import { StyledContainer, TableCSS } from '../styles/MembersStyled';
import { toast } from 'react-toastify';
import CreateContactPicker from '../../../BulkUpload/Contact';
import SingleContactModal from '../../../BulkUpload/Contact/SingleModal';
import { BiArchiveIn, BiArchiveOut } from 'react-icons/bi';
import { AiOutlineApi } from 'react-icons/ai';
import { ActionStyles } from '../../../../Admin/reusableStyles';
import { BootstrapToolTip } from '../../../../../_elements/ToolTip';
import { BsPencil } from 'react-icons/bs';
import { GoToChannel } from '../../../../../_elements/Links';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaStickyNote } from 'react-icons/fa';

const getSortedContacts = (contacts) => {
    return contacts.sort((a, b) => {
        if (a?.name < b?.name) return -1;
        if (a?.name > b?.name) return 1;
        return 0;
    });
};

const ContactRow = ({
    contact,
    index,
    setShowModal,
    setFilteredContacts,
    teamId,
    onShowNotes,
    isSelected,
    onToggleSelect,
    onEnrich,
}) => {
    const [isBusy, setIsBusy] = useState(false);
    const handleContactStatus = async (contact) => {
        try {
            if (!contact?._id) return;
            setIsBusy(contact);
            const status = contact?.status === 'archive' ? 'Active' : 'Archive';
            await fetchWrapper.patch(`contacts/status/${contact._id}?team=${teamId}`);
            toast.success(`Contact status updated to ${status}`);
            setFilteredContacts((prev) =>
                prev.map((_contact) =>
                    _contact._id === contact._id ? { ..._contact, status: status?.toLocaleLowerCase() } : _contact
                )
            );
        } catch (err) {
            toast.error(err?.message || 'Something went wrong');
        } finally {
            setIsBusy(false);
        }
    };
    return (
        <tr key={index}>
            <td>
                <Form.Check
                    type="checkbox"
                    checked={!!isSelected}
                    onChange={() => onToggleSelect && onToggleSelect(contact?._id)}
                />
            </td>
            <td>{contact?.name}</td>
            <td>
                <div className="info-cell">{contact?.category || '-'}</div>
            </td>
            <td>{contact?.phone}</td>
            <td>{contact?.email || '-'}</td>
            <td>
                <GoToChannel channel={contact?.chatroomInfo} />
            </td>
            <td>
                <span className={`badge badge-${contact?.status === 'archive' ? 'danger' : 'success'}`}>
                    {contact?.status === 'archive' ? 'archived' : 'active'}
                </span>
            </td>
            <td>
                <div className="d-flex">
                    <ActionStyles>
                        <BootstrapToolTip text="Edit Contact">
                            <BsPencil className="icon edit" onClick={() => setShowModal(contact)} />
                        </BootstrapToolTip>

                        <BootstrapToolTip text="Enrich Contact Phone">
                            <AiOutlineApi
                                className="icon"
                                style={{ color: '#0d6efd', marginLeft: 8, cursor: 'pointer' }}
                                onClick={() => onEnrich && onEnrich(contact)}
                            />
                        </BootstrapToolTip>
                        <BootstrapToolTip text="Contact Notes">
                            <FaStickyNote className="icon edit" onClick={() => onShowNotes && onShowNotes(contact)} />
                        </BootstrapToolTip>

                        <div>
                            {isBusy && isBusy?._id === contact._id ? (
                                <VscLoading className="spin" />
                            ) : (
                                <Fragment>
                                    <BootstrapToolTip
                                        text={contact?.status === 'archive' ? 'Unarchive Contact' : 'Archive Contact'}
                                    >
                                        {contact?.status === 'archive' ? (
                                            <BiArchiveOut
                                                className="icon archiveOut"
                                                onClick={() => handleContactStatus(contact)}
                                            />
                                        ) : (
                                            <BiArchiveIn
                                                className="icon archiveIn"
                                                onClick={() => handleContactStatus(contact)}
                                            />
                                        )}
                                    </BootstrapToolTip>
                                </Fragment>
                            )}
                        </div>
                    </ActionStyles>
                </div>
            </td>
        </tr>
    );
};
const TeamContacts = ({ teams }) => {
    const [isBusy, setIsBusy] = useState(false);
    const [filteredContacts, setFilteredContacts] = useState(null);
    const [contacts, setContacts] = useState(null);
    const [contactSearch, setContactSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [selectedContactForNotes, setSelectedContactForNotes] = useState(null);
    const [contactNotes, setContactNotes] = useState([]);
    const [newContactNote, setNewContactNote] = useState('');
    const [isLoadingNotes, setIsLoadingNotes] = useState(false);
    const [isSavingNote, setIsSavingNote] = useState(false);
    const [selectedContactIds, setSelectedContactIds] = useState([]);
    const [isBatchEnriching, setIsBatchEnriching] = useState(false);
    const [enrichmentReview, setEnrichmentReview] = useState(null); // { contactId, jobId, candidates }
    const [showUrlModal, setShowUrlModal] = useState(false);
    const [enrichmentUrl, setEnrichmentUrl] = useState('');
    const [urlDiscoveryResults, setUrlDiscoveryResults] = useState(null); // { seedUrl, contacts }
    const [enrichingContactIds, setEnrichingContactIds] = useState([]); // per-contact in-flight enrich
    const [lastSingleEnrichAt, setLastSingleEnrichAt] = useState({}); // contactId -> timestamp
    const [infoSortAsc, setInfoSortAsc] = useState(true);
    const [isMerging, setIsMerging] = useState(false);
    const [isRefreshingCandidates, setIsRefreshingCandidates] = useState(false);
    const [loadingContactEnrichments, setLoadingContactEnrichments] = useState(false);
    const [loadingContactEnrichmentStatus, setLoadingContactEnrichmentStatus] = useState('');
    const teamId = getTeamIdFromURL();
    let teamArr = teams.filter((team) => team.id === teamId);
    let team = teamArr[0];

    const sortByInfo = (list, asc) => {
        const copy = [...(list || [])];
        copy.sort((a, b) => {
            const aCat = (a.category || '').toLowerCase();
            const bCat = (b.category || '').toLowerCase();
            if (aCat < bCat) return asc ? -1 : 1;
            if (aCat > bCat) return asc ? 1 : -1;
            const aName = (a.name || '').toLowerCase();
            const bName = (b.name || '').toLowerCase();
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return 0;
        });
        return copy;
    };

    const getTeamContacts = async () => {
        try {
            const response = await fetchWrapper.get(`contacts?team=${teamId}&showArchive=true&limit=500`);
            setContacts(response || []);
            setFilteredContacts(sortByInfo(response || [], infoSortAsc));
        } catch (error) {
            console.log('ERROR', error);
            if (error?.name === 'AbortError') {
                return;
            }
            toast.error(error.message);
        } finally {
        }
    };

    useEffect(() => {
        if (teamId) {
            getTeamContacts();
        }
    }, [team, teamId]);

    const handleSearchChange = (e) => {
        const value = e.target.value || '';
        setContactSearch(value);
        const _temp = (contacts || []).filter(
            (contact) =>
                contact?.name?.toLowerCase().includes(value.toLowerCase()) ||
                contact?.category?.toLowerCase().includes(value.toLowerCase()) ||
                contact?.phone?.toLowerCase().includes(value.toLowerCase()) ||
                contact?.email?.toLowerCase().includes(value.toLowerCase())
        );

        setFilteredContacts(sortByInfo(_temp, infoSortAsc));
    };

    const toggleInfoSort = () => {
        setInfoSortAsc((prev) => {
            const next = !prev;
            setFilteredContacts((current) => sortByInfo(current || [], next));
            return next;
        });
    };

    const handleMergeSelected = async () => {
        if (selectedContactIds.length < 2) {
            toast.info('Select at least two contacts to merge.');
            return;
        }

        const selected = (contacts || []).filter((c) => selectedContactIds.includes(c._id));
        if (selected.length < 2) {
            toast.error('Unable to load selected contacts for merge.');
            return;
        }

        const nameSet = new Set(selected.map((c) => (c.name || '').trim().toLowerCase()).filter((v) => !!v));

        if (nameSet.size > 1) {
            toast.error('Merge is only allowed when all selected contacts have the same name.');
            return;
        }

        const [primary, ...rest] = selected;
        const mergeIds = rest.map((c) => c._id).filter(Boolean);

        if (!mergeIds.length) {
            return;
        }

        if (!window.confirm('Merge selected contacts into one and archive the others?')) {
            return;
        }

        try {
            setIsMerging(true);
            await fetchWrapper.post('contacts/merge', {
                team: teamId,
                primaryContactId: primary._id,
                mergeContactIds: mergeIds,
            });
            toast.success('Contacts merged successfully');
            setSelectedContactIds([primary._id]);
            await getTeamContacts();
        } catch (error) {
            toast.error(error?.message || 'Failed to merge contacts');
        } finally {
            setIsMerging(false);
        }
    };

    const toggleSelectContact = (contactId) => {
        if (!contactId) return;
        setSelectedContactIds((prev) => {
            const set = new Set(prev);
            if (set.has(contactId)) {
                set.delete(contactId);
            } else {
                set.add(contactId);
            }
            return Array.from(set);
        });
    };

    const toggleSelectAll = () => {
        if (!filteredContacts || filteredContacts.length === 0) return;
        if (selectedContactIds.length === filteredContacts.length) {
            setSelectedContactIds([]);
        } else {
            setSelectedContactIds(filteredContacts.map((c) => c._id).filter(Boolean));
        }
    };

    const handleBatchEnrich = async () => {
        if (!selectedContactIds.length) return;
        setIsBatchEnriching(true);
        try {
            const contactsToEnrich = (contacts || []).filter((c) => selectedContactIds.includes(c._id));
            const payload = {
                contacts: contactsToEnrich.map((c) => ({
                    contactId: c._id,
                    businessName: c.company || '',
                    city: c.city || '',
                    state: c.state || '',
                    website: c.website || '',
                    source: 'teamContacts',
                })),
            };

            await fetchWrapper.post('contacts/enrichment/jobs', payload);
            toast.success('Enrichment started for selected contacts');
        } catch (error) {
            toast.error(error?.message || 'Failed to start enrichment');
        } finally {
            setIsBatchEnriching(false);
        }
    };

    const handleSingleEnrich = async (contact) => {
        if (!contact?._id) return;
        try {
            setLoadingContactEnrichments(true);
            let summary = '';
            try {
                setLoadingContactEnrichmentStatus('(1/3) Fetching contact enrichment summary ...');
                const summaryResp = await fetchWrapper.post('contacts/enrichment/summary', {
                    contactId: contact._id,
                });
                summary = (summaryResp && summaryResp.summary) || '';
            } catch (e) {
                // summary is optional; ignore failures
            }

            // First, try to load an existing enrichment job so the user can
            // revisit previous results without re-running web discovery.
            try {
                setLoadingContactEnrichmentStatus('(2/3) Loading existing enrichment job ...');
                const existing = await fetchWrapper.get(`contacts/enrichment/contact/${contact._id}`);
                if (
                    existing &&
                    existing.job &&
                    Array.isArray(existing.job.candidates) &&
                    existing.job.candidates.length
                ) {
                    setEnrichmentReview({
                        contactId: contact._id,
                        jobId: existing.job.id || existing.job._id,
                        candidates: existing.job.candidates || [],
                        summary,
                    });
                    return;
                }
            } catch (e) {
                // If lookup fails, fall through to creating a new job.
            }

            const now = Date.now();
            if (enrichingContactIds.includes(contact._id)) {
                toast.info('Working... still pulling enrichment results for this contact.');
                return;
            }
            if (lastSingleEnrichAt[contact._id] && now - lastSingleEnrichAt[contact._id] < 30000) {
                toast.info('Working... enrichment was just started. Please wait up to 30 seconds.');
                return;
            }

            setEnrichingContactIds((prev) => [...prev, contact._id]);
            setLastSingleEnrichAt((prev) => ({ ...prev, [contact._id]: now }));
            const payload = {
                contacts: [
                    {
                        contactId: contact._id,
                        businessName: contact.company || '',
                        city: contact.city || '',
                        state: contact.state || '',
                        website: contact.website || '',
                        source: 'teamContacts',
                    },
                ],
            };
            setLoadingContactEnrichmentStatus('(3/3) Fetching and Preparing enrichment review ...');
            const result = await fetchWrapper.post('contacts/enrichment/jobs', payload);

            // If backend returns job id + candidates immediately, open review modal
            if (result && result.jobs && result.jobs[0]) {
                setEnrichmentReview({
                    contactId: contact._id,
                    jobId: result.jobs[0].id,
                    candidates: result.jobs[0].candidates || [],
                    summary,
                });
            }
            toast.success('Enrichment started for contact');
        } catch (error) {
            toast.error(error?.message || 'Failed to start enrichment');
        } finally {
            setEnrichingContactIds((prev) => prev.filter((id) => id !== contact._id));
            setLoadingContactEnrichments(false);
            setLoadingContactEnrichmentStatus('');
        }
    };

    const handleRefreshCandidates = async () => {
        if (!enrichmentReview || !enrichmentReview.contactId) return;
        try {
            setIsRefreshingCandidates(true);
            const contactId = enrichmentReview.contactId;
            const baseContact = (contacts || []).find((c) => c._id === contactId) || {};

            let summary = '';
            try {
                const summaryResp = await fetchWrapper.post('contacts/enrichment/summary', {
                    contactId,
                });
                summary = (summaryResp && summaryResp.summary) || '';
            } catch (e) {
                // summary is optional; ignore failures
            }

            const payload = {
                contacts: [
                    {
                        contactId,
                        businessName: baseContact.company || '',
                        city: baseContact.city || '',
                        state: baseContact.state || '',
                        website: baseContact.website || '',
                        source: 'teamContacts',
                        forceWebDiscovery: true,
                    },
                ],
            };

            const result = await fetchWrapper.post('contacts/enrichment/jobs', payload);
            if (result && result.jobs && result.jobs[0]) {
                setEnrichmentReview({
                    contactId,
                    jobId: result.jobs[0].id,
                    candidates: result.jobs[0].candidates || [],
                    summary,
                });
            }

            toast.success('Enrichment candidates refreshed');
        } catch (error) {
            toast.error(error?.message || 'Failed to refresh candidates');
        } finally {
            setIsRefreshingCandidates(false);
        }
    };

    const handleApproveCandidate = async (candidate) => {
        if (!enrichmentReview || !candidate) return;
        try {
            await fetchWrapper.post(`contacts/enrichment/candidates/${candidate.id}/decision`, {
                decision: 'APPROVE',
                contactId: enrichmentReview.contactId,
                phone: candidate.phoneE164 || candidate.phone,
                email: candidate.email || '',
            });
            toast.success('Contact phone updated from enrichment');
            setEnrichmentReview(null);
            await getTeamContacts();
        } catch (error) {
            toast.error(error?.message || 'Failed to approve candidate');
        }
    };

    const handleCreateNewFromCandidate = async (candidate) => {
        if (!enrichmentReview || !candidate) return;
        try {
            setIsBusy(true);
            const baseContact = (contacts || []).find((c) => c._id === enrichmentReview.contactId) || {};
            const name = baseContact.name || baseContact.company || 'Unnamed Contact';
            const existingInfo = (baseContact.category || '').trim();
            const trailingParts = [];
            if (candidate.address) trailingParts.push(`Address: ${candidate.address}`);
            if (existingInfo) trailingParts.push(existingInfo);
            let info = trailingParts.join(' | ');
            if (candidate.businessCategory) {
                const catLabel = candidate.businessCategory;
                info = info ? `${catLabel} - ${info}` : catLabel;
            }

            const payload = {
                team: teamId,
                name,
                phone: candidate.phoneE164 || candidate.phone || '',
                email: candidate.email || '',
                category: info ? info.slice(0, 500) : undefined,
            };

            await fetchWrapper.post(`contacts?team=${teamId}`, payload);
            toast.success('New contact created from enrichment candidate');
            setEnrichmentReview(null);
            await getTeamContacts();
        } catch (error) {
            toast.error(error?.message || 'Failed to create contact from candidate');
        } finally {
            setIsBusy(false);
        }
    };

    const handleEnrichFromUrl = async () => {
        const url = (enrichmentUrl || '').trim();
        if (!url) return;
        try {
            setIsBusy(true);
            const payload = { seedUrl: url };
            const result = await fetchWrapper.post('contacts/enrichment/directory', payload);
            if (result && Array.isArray(result.contacts) && result.contacts.length > 0) {
                setUrlDiscoveryResults(result);
                toast.success(`Found ${result.contacts.length} contact(s) on the website`);
            } else {
                toast.success('No directory contacts found for this URL');
            }
            setShowUrlModal(false);
            setEnrichmentUrl('');
        } catch (error) {
            toast.error(error?.message || 'Failed to start URL enrichment');
        } finally {
            setIsBusy(false);
        }
    };

    const loadContactNotes = async (contact) => {
        if (!contact?._id) return;
        try {
            setIsLoadingNotes(true);
            const notes = await fetchWrapper.get(`contacts/${contact._id}/notes?team=${teamId}`);
            setContactNotes(notes || []);
        } catch (error) {
            console.log('ERROR', error);
            if (error?.name === 'AbortError') {
                return;
            }
            toast.error(error.message || 'Failed to load contact notes');
        } finally {
            setIsLoadingNotes(false);
        }
    };

    const handleOpenNotes = async (contact) => {
        setSelectedContactForNotes(contact);
        setShowNotesModal(true);
        setNewContactNote('');
        await loadContactNotes(contact);
    };

    const handleCloseNotes = () => {
        setShowNotesModal(false);
        setSelectedContactForNotes(null);
        setContactNotes([]);
        setNewContactNote('');
    };

    const handleSaveContactNote = async () => {
        if (!selectedContactForNotes?._id || !newContactNote.trim()) return;
        try {
            setIsSavingNote(true);
            const payload = { team: teamId, text: newContactNote.trim() };
            const created = await fetchWrapper.post(`contacts/${selectedContactForNotes._id}/notes`, payload);
            setNewContactNote('');
            setContactNotes((prev) => [...(prev || []), created]);
        } catch (error) {
            toast.error(error?.message || 'Failed to save note');
        } finally {
            setIsSavingNote(false);
        }
    };

    return (
        <StyledContainer>
            <h1 className="mb-4">Contacts</h1>
            <Fragment>
                <div className="d-flex justify-content-between ">
                    <div style={{ display: 'flex' }}>
                        <input
                            className="input"
                            onChange={handleSearchChange}
                            value={contactSearch}
                            placeholder="Search for Contact"
                            style={{ minWidth: '360px' }}
                        />
                        <div className="ml-2 d-flex">
                            <CreateContactPicker onCreateOrUpdate={getTeamContacts} />
                        </div>
                    </div>
                    <div className="d-flex gap-2 ms-3">
                        <Button
                            variant="outline-primary"
                            size="sm"
                            disabled={!selectedContactIds.length || isBatchEnriching}
                            onClick={handleBatchEnrich}
                        >
                            {isBatchEnriching ? 'Enriching...' : 'Enrich Selected'}
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={() => setShowUrlModal(true)}>
                            Enrich from URL
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={toggleInfoSort}>
                            Sort Info {infoSortAsc ? 'A→Z' : 'Z→A'}
                        </Button>
                        <Button
                            variant="outline-danger"
                            size="sm"
                            disabled={selectedContactIds.length < 2 || isMerging}
                            onClick={handleMergeSelected}
                        >
                            {isMerging ? 'Merging...' : 'Merge Selected'}
                        </Button>
                    </div>
                </div>
            </Fragment>
            <Fragment>
                {!filteredContacts ? (
                    <h4 className="text-center">
                        <VscLoading className="spin" fontSize="42" />
                    </h4>
                ) : (
                    <div className="custom-card mt-4">
                        <TableCSS>
                            <thead>
                                <tr>
                                    <th>
                                        <Form.Check
                                            type="checkbox"
                                            checked={
                                                !!filteredContacts &&
                                                filteredContacts.length > 0 &&
                                                selectedContactIds.length === filteredContacts.length
                                            }
                                            onChange={toggleSelectAll}
                                        />
                                    </th>
                                    <th>Name</th>
                                    <th>Info</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Channel</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                    {/* <th>Channel</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredContacts && filteredContacts.length > 0 ? (
                                    <Fragment>
                                        {filteredContacts.map((contact, index) => {
                                            return (
                                                <ContactRow
                                                    key={contact?._id || index}
                                                    contact={contact}
                                                    teamId={teamId}
                                                    setShowModal={setShowModal}
                                                    setFilteredContacts={setFilteredContacts}
                                                    isSelected={selectedContactIds.includes(contact._id)}
                                                    onToggleSelect={toggleSelectContact}
                                                    onEnrich={handleSingleEnrich}
                                                    onShowNotes={handleOpenNotes}
                                                />
                                            );
                                        })}
                                    </Fragment>
                                ) : (
                                    <tr>
                                        <td colSpan="100">
                                            <h4 className="text-center">Oops! No Contact Found</h4>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </TableCSS>
                    </div>
                )}
                <SingleContactModal
                    data={showModal}
                    onCreateOrUpdate={getTeamContacts}
                    show={!!showModal}
                    setShow={setShowModal}
                />

                {/* Website discovery review modal */}
                {urlDiscoveryResults && Array.isArray(urlDiscoveryResults.contacts) && (
                    <Modal
                        show={!!urlDiscoveryResults}
                        onHide={() => setUrlDiscoveryResults(null)}
                        size="lg"
                        centered
                        backdrop="static"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Contacts Discovered from Website</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p className="text-muted">
                                Source URL:{' '}
                                <a href={urlDiscoveryResults.seedUrl} target="_blank" rel="noreferrer">
                                    {urlDiscoveryResults.seedUrl}
                                </a>
                            </p>
                            {urlDiscoveryResults.contacts.length === 0 && (
                                <p className="text-muted mb-0">No contacts were discovered on this website.</p>
                            )}
                            {urlDiscoveryResults.contacts.length > 0 && (
                                <div>
                                    {urlDiscoveryResults.contacts.map((c, idx) => (
                                        <div key={idx} className="mb-3 p-2 border rounded">
                                            <div>
                                                <strong>{c.businessName || 'Unnamed Contact'}</strong>
                                                {c.city || c.state ? (
                                                    <span className="text-muted ms-2">
                                                        {c.city || ''}
                                                        {c.city && c.state ? ', ' : ''}
                                                        {c.state || ''}
                                                    </span>
                                                ) : null}
                                            </div>
                                            {c.website && (
                                                <div className="small">
                                                    <a href={c.website} target="_blank" rel="noreferrer">
                                                        {c.website}
                                                    </a>
                                                </div>
                                            )}
                                            {c.phones && c.phones.length > 0 && (
                                                <div className="mt-2">
                                                    <div className="small text-muted mb-1">Phone candidates:</div>
                                                    {c.phones.map((p, pIdx) => (
                                                        <div
                                                            key={pIdx}
                                                            className="d-flex align-items-center justify-content-between mb-1"
                                                        >
                                                            <div>
                                                                <strong>{p.phoneE164 || p.raw}</strong>
                                                                {typeof p.confidence === 'number' && (
                                                                    <span className="text-muted ms-2">
                                                                        (score: {p.confidence.toFixed(2)})
                                                                    </span>
                                                                )}
                                                                {p.type && (
                                                                    <span className="badge bg-secondary ms-2">
                                                                        {p.type}
                                                                    </span>
                                                                )}
                                                                {p.explanation && (
                                                                    <div className="small text-muted">
                                                                        {p.explanation}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <Button
                                                                variant="success"
                                                                size="sm"
                                                                onClick={async () => {
                                                                    try {
                                                                        const businessName = (
                                                                            c.businessName || ''
                                                                        ).trim();
                                                                        const phoneRaw = p.phoneE164 || p.raw || '';

                                                                        const basePayload = {
                                                                            team: teamId,
                                                                            name: businessName || 'Unnamed Contact',
                                                                            phone: phoneRaw, // may be normalized or dropped by backend
                                                                            email:
                                                                                c.emails && c.emails[0]
                                                                                    ? c.emails[0]
                                                                                    : '',
                                                                        };

                                                                        await fetchWrapper.post(
                                                                            'contacts',
                                                                            basePayload
                                                                        );
                                                                        toast.success(
                                                                            'Contact created from website discovery'
                                                                        );
                                                                        await getTeamContacts();
                                                                    } catch (err) {
                                                                        toast.error(
                                                                            err?.message || 'Failed to create contact'
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Create Contact
                                                            </Button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {c.emails && c.emails.length > 0 && (
                                                <div className="mt-2">
                                                    <div className="small text-muted mb-1">Email(s):</div>
                                                    {c.emails.map((emailVal, eIdx) => (
                                                        <div key={eIdx} className="small">
                                                            {emailVal}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {(!c.phones || c.phones.length === 0) && (
                                                <div className="mt-2">
                                                    <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={async () => {
                                                            try {
                                                                const businessName = (c.businessName || '').trim();
                                                                const basePayload = {
                                                                    team: teamId,
                                                                    name: businessName || 'Unnamed Contact',
                                                                    phone: '',
                                                                    email: c.emails && c.emails[0] ? c.emails[0] : '',
                                                                };

                                                                await fetchWrapper.post('contacts', basePayload);
                                                                toast.success('Contact created from website discovery');
                                                                await getTeamContacts();
                                                            } catch (err) {
                                                                toast.error(err?.message || 'Failed to create contact');
                                                            }
                                                        }}
                                                    >
                                                        Create Contact (no phone)
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setUrlDiscoveryResults(null)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* URL-based enrichment modal */}
                <Modal show={showUrlModal} onHide={() => setShowUrlModal(false)} centered backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Enrich Contact from Website URL</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>Business Website URL</Form.Label>
                            <Form.Control
                                type="url"
                                value={enrichmentUrl}
                                onChange={(e) => setEnrichmentUrl(e.target.value)}
                                placeholder="https://example.com"
                            />
                            <Form.Text className="text-muted">
                                Paste a public business website; the enrichment engine will search for compliant
                                business contact info.
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowUrlModal(false)} disabled={isBusy}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleEnrichFromUrl}
                            disabled={!enrichmentUrl.trim() || isBusy}
                        >
                            {isBusy && <VscLoading className="spin mr-2" />}
                            Start Enrichment
                        </Button>
                    </Modal.Footer>
                </Modal>
                {loadingContactEnrichments && (
                    <Modal show={loadingContactEnrichments} centered>
                        <Modal.Body>
                            <div className="text-center p-5">
                                <div className="mb-4">
                                    <VscLoading className="spin" fontSize="64" />
                                </div>
                                <h1>Loading Contact Enrichments ...</h1>
                                <p className="text-muted">This might take a while. Please wait a moment...</p>
                                <p className="text-muted">{loadingContactEnrichmentStatus}</p>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}
                {isBatchEnriching && (
                    <Modal show={isBatchEnriching} centered>
                        <Modal.Body>
                            <div className="text-center p-5">
                                <div className="mb-4">
                                    <VscLoading className="spin" fontSize="64" />
                                </div>
                                <h1>Enriching ...</h1>
                                <p className="text-muted">This might take a while. Please wait a moment...</p>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}

                {/* Enrichment review modal (simple placeholder; backend can return candidates shape) */}
                {enrichmentReview && (
                    <Modal show={!!enrichmentReview} onHide={() => setEnrichmentReview(null)} size="lg" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Enriched Phone Candidates</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {enrichmentReview.summary && (
                                <div className="mb-3 p-2 bg-light border rounded">
                                    <div className="fw-bold">Bob's summary</div>
                                    <div className="small">{enrichmentReview.summary}</div>
                                </div>
                            )}

                            {(!enrichmentReview.candidates || enrichmentReview.candidates.length === 0) && (
                                <p className="text-muted mb-0">No candidates returned yet for this job.</p>
                            )}
                            {enrichmentReview.candidates && enrichmentReview.candidates.length > 0 && (
                                <div>
                                    {enrichmentReview.candidates.map((candidate) => (
                                        <div key={candidate.id} className="mb-3 p-2 border rounded">
                                            <div>
                                                <strong>{candidate.phone}</strong>{' '}
                                                <span className="text-muted">(score: {candidate.score})</span>
                                                {candidate.email && (
                                                    <div className="small">Email: {candidate.email}</div>
                                                )}
                                                {candidate.businessCategory && (
                                                    <div className="small">Category: {candidate.businessCategory}</div>
                                                )}
                                                {candidate.address && (
                                                    <div className="small">Address: {candidate.address}</div>
                                                )}
                                            </div>
                                            {candidate.source && (
                                                <div className="small text-muted">Source: {candidate.source}</div>
                                            )}
                                            {candidate.explanation && (
                                                <div className="small mt-1">{candidate.explanation}</div>
                                            )}
                                            <div className="mt-2 d-flex gap-2">
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={() => handleApproveCandidate(candidate)}
                                                >
                                                    Update Existing Contact
                                                </Button>
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => handleCreateNewFromCandidate(candidate)}
                                                >
                                                    Create New Contact
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="outline-secondary"
                                onClick={handleRefreshCandidates}
                                disabled={isRefreshingCandidates}
                            >
                                {isRefreshingCandidates ? 'Refreshing...' : 'Refresh Candidates'}
                            </Button>
                            <Button variant="secondary" onClick={() => setEnrichmentReview(null)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {showNotesModal && selectedContactForNotes && (
                    <Modal show={showNotesModal} onHide={handleCloseNotes} size="md" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Contact Notes - {selectedContactForNotes?.name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {isLoadingNotes ? (
                                <h4 className="text-center">
                                    <VscLoading className="spin" fontSize="32" />
                                </h4>
                            ) : contactNotes && contactNotes.length > 0 ? (
                                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                    {contactNotes.map((note) => (
                                        <div key={note._id} className="mb-2 pb-2 border-bottom">
                                            <div className="small text-muted">
                                                {note.createdAt ? new Date(note.createdAt).toLocaleString() : ''} -{' '}
                                                {note?.createdBy?.name || 'Supervisor'}
                                            </div>
                                            <div>{note.text}</div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p className="mb-3 text-muted">No notes yet for this contact.</p>
                            )}

                            <Form.Group className="mt-3">
                                <Form.Label>Add Note</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={newContactNote}
                                    onChange={(e) => setNewContactNote(e.target.value)}
                                    placeholder="Add a note about this contact..."
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseNotes} disabled={isSavingNote}>
                                Close
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleSaveContactNote}
                                disabled={isSavingNote || !newContactNote.trim()}
                            >
                                {isSavingNote ? <VscLoading className="spin" /> : 'Save Note'}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </Fragment>
        </StyledContainer>
    );
};

const mapStateToProps = (state) => ({
    teams: state.teams.teams,
    userRole: state.user?.user?.role,
});

export default connect(mapStateToProps, {})(TeamContacts);
